import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { formatPasswordRefusal, getUnmetPasswordRules, PasswordRulesContext } from './passwordRules';

/**
 * Проверка задаваемого пароля на правила надёжности — одна для полей и для схем форм: `true`, если пароль
 * выполняет все правила, которые форма проверяет сама, иначе — текст отказа, называющий каждую причину.
 * Владелец пароля передаётся при каждой проверке: форма, где его данные набираются тут же, берёт их
 * из проверяемых значений, а не из прошлого рендера.
 */
export const usePasswordStrengthValidator = () => {
  const { t } = useTranslation('common');

  return useCallback(
    (password: string, context: PasswordRulesContext): true | string => {
      const unmetRules = getUnmetPasswordRules(password, context);
      return unmetRules.length === 0 || formatPasswordRefusal(unmetRules, t);
    },
    [t],
  );
};
